export default {
  name: 'Pagination',
  props: {
    pagination: {
      required: true,
      type: Object
    }
  },
  emits: ['fetch'],
  computed: {
    page_sizes: function page_sizes() {
      return [10, 20, 50, 80, 100, 120, 150];
    }
  },
  methods: {
    changePage: function changePage(page) {
      this.pagination.current_page = page;
      this.$emit('fetch');
    },
    changeSize: function changeSize(size) {
      this.pagination.per_page = size;
      this.$emit('fetch');
    }
  }
};